import React from 'react'
import PageHero from '../components/PageHero'
import PageLayout from '../components/PageLayout'

const AboutPage: React.FC = () => {
    const valuesArr = [
        {
            title: 'Authenticity',
            description: 'We are blerds and nerds',
            icon: 'fas fa-atom fa-stack-1x fa-inverse'
        },
        {
            title: 'Connection',
            description: "We will leverage our community's collective genius to build and empower others",
            icon: 'fas fa-comments fa-stack-1x fa-inverse'
        },
        { title: 'Growth', description: 'We value learning, knowledge and learning for life', icon: 'fas fa-user-graduate fa-stack-1x fa-inverse' },
        { title: 'Impact', description: 'We chart our impact to improve and advance our work', icon: 'fas fa-chart-bar fa-stack-1x fa-inverse' },
        {
            title: 'Equity',
            description: 'We see the beauty in our differences and recognize the power in supporting the community in any way it needs.',
            icon: 'fas fa-medal fa-stack-1x fa-inverse'
        },
        { title: 'Innovation', description: 'We believe in the power of change and adaptability', icon: 'fas fa-lightbulb fa-stack-1x fa-inverse' },
        { title: 'Joy', description: 'We create safe spaces that empower, engage and inspire others', icon: 'fas fa-star fa-stack-1x fa-inverse' }
    ]

    return (
        <PageLayout>
            <PageHero
                title="About the House"
                image="./img/HOACC.png"
                imageAlt="The House of Afros, Capes and Curls"
                imageClassName="page-hero__image--contain"
            />
            <section className="about-section">
                <div className="container">
                    <div className="row text-center mt-4">
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                <i className="fas fa-circle fa-stack-2x text-gray icon-background-gold"></i>
                                <i className="fas fa-gamepad fa-stack-1x fa-inverse"></i>
                            </span>
                            <h2 className="h4 my-3">Who We Are</h2>
                            <p className="text-muted">
                                We are always looking for ways to build community, connect people, impact change, and create programming that generates a sense
                                of community and belonging.
                            </p>
                        </div>
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                <i className="fas fa-circle fa-stack-2x text-gray icon-background-gold"></i>
                                <i className="fas fa-hand-spock fa-stack-1x fa-inverse"></i>
                            </span>
                            <h2 className="h4 my-3">Our Vision</h2>
                            <p className="text-muted">
                                The House was created as a vehicle for POC to build more inclusive environments to engage around seemingly non-traditional
                                spaces such as gaming, comics, science fiction, media, and technology. We want to ensure that the representation of and
                                consumption by POC is normalized rather than seen as an anomaly. We strive to increase representation for adults and youth of
                                color, create programs that build community and create programming that generates a sense of belonging where the community as a
                                whole can discuss pertinent and sensitive issues using science fiction, fantasy, comics, and games as a catalyst for
                                conversation.
                            </p>
                        </div>
                        <div className="col-md-4">
                            <span className="fa-stack fa-4x">
                                <i className="fas fa-circle fa-stack-2x text-gray icon-background-gold"></i>
                                <i className="fas fa-dice-d20 fa-stack-1x fa-inverse"></i>
                            </span>
                            <h2 className="h4 my-3">What We Do</h2>
                            <p className="text-muted">
                                We create space for community members of all backgrounds to discuss sensitive issues using &quot;geek culture&quot; as the
                                catalyst for the conversation.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 col-md-6 mb-4">
                            <img className="img-fluid rounded shadow-sm w-100" src="./img/about/about1.jpg" alt="HOACC community members at an event" loading="lazy" />
                        </div>
                        <div className="col-12 col-md-6 mb-4">
                            <img className="img-fluid rounded shadow-sm w-100" src="./img/about/about2.jpg" alt="HOACC team members at a community gathering" loading="lazy" />
                        </div>
                    </div>
                    <div className="row mt-4">
                        {valuesArr.map((value, idx) => (
                            <div className="col-md-3" style={{ textAlign: 'center' }} key={idx}>
                                <div>
                                    {/* <FontAwesomeIcon icon={['fab', value.icon]} /> */}
                                    <span className="fa-stack fa-2x my-2">
                                        <i className="fas fa-circle fa-stack-2x text-blue gradient icon-background-gold"></i>
                                        <i className={value.icon}></i>
                                    </span>
                                    <h3 className="h5">{value.title}</h3>
                                    <p className="text-muted">{value.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </PageLayout>
    )
}

export default AboutPage
